"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _context = _interopRequireDefault(require("../context"));

var _presets = require("../utils/presets");

var _useMergedConfig = _interopRequireDefault(require("../hooks/useMergedConfig"));

var _useWidth = _interopRequireDefault(require("../hooks/useWidth"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var initialConfig = (0, _presets.createDefaultLayout)(); // eslint-disable-next-line react/prop-types

var Root = function Root(_ref) {
  var children = _ref.children,
      config = _ref.config;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      opened = _useState4[0],
      setOpened = _useState4[1];

  var mergedConfig = (0, _useMergedConfig["default"])(config, initialConfig);
  var screen = (0, _useWidth["default"])(); // screen could be null at first render

  return _react["default"].createElement(_context["default"].Provider, {
    value: _objectSpread({}, mergedConfig, {
      screen: screen,
      collapsed: collapsed,
      setCollapsed: setCollapsed,
      opened: opened,
      setOpened: setOpened
    })
  }, _react["default"].createElement(_CssBaseline["default"], null), children);
};

var createScreenPropTypes = function createScreenPropTypes(valPropTypes) {
  return _propTypes["default"].shape({
    xs: valPropTypes,
    sm: valPropTypes,
    md: valPropTypes,
    lg: valPropTypes,
    xl: valPropTypes
  });
};

Root.propTypes = {
  // from HOC
  // general
  config: _propTypes["default"].shape({
    clipped: _propTypes["default"].oneOfType([_propTypes["default"].bool, createScreenPropTypes(_propTypes["default"].bool)]),
    collapsible: _propTypes["default"].oneOfType([_propTypes["default"].bool, createScreenPropTypes(_propTypes["default"].bool)]),
    collapsedWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, createScreenPropTypes(_propTypes["default"].number)]),
    collapsed: _propTypes["default"].bool,
    navVariant: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['permanent', 'persistent', 'temporary']), createScreenPropTypes(_propTypes["default"].oneOf(['permanent', 'persistent', 'temporary']))]),
    navWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, createScreenPropTypes(_propTypes["default"].number)]),
    navAnchor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['left', 'bottom']), createScreenPropTypes(_propTypes["default"].oneOf(['left', 'bottom']))]),
    headerPosition: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['static', 'relative', 'sticky', 'fixed', 'absolute']), createScreenPropTypes(_propTypes["default"].oneOf(['static', 'relative', 'sticky', 'fixed', 'absolute']))]),
    squeezed: _propTypes["default"].oneOfType([_propTypes["default"].bool, createScreenPropTypes(_propTypes["default"].bool)]),
    footerShrink: _propTypes["default"].oneOfType([_propTypes["default"].bool, createScreenPropTypes(_propTypes["default"].bool)])
  }),
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired
};
Root.defaultProps = {
  config: initialConfig
};
var _default = Root;
exports["default"] = _default;